export const mapOffersLink = response => {
  return {
    fromAgentsPropsCountDisplay: response.fromAgentsPropsCountDisplay || undefined,
    fromAgentsPropsCountUrl: response.fromAgentsPropsCountUrl || undefined,
    fromDeveloperPropsCountDisplay: response.fromDeveloperPropsCountDisplay || undefined,
    fromDeveloperPropsCountUrl: response.fromDeveloperPropsCountUrl || undefined,
    fromAllPropsCountDisplay: response.fromAllPropsCountDisplay || undefined,
    fromAllPropsCountUrl: response.fromAllPropsCountUrl || undefined
  };
};